import i18n from "i18next";
import { useContext, useEffect, useState } from "react";
import { TypeParams } from "./types";
import { Spin } from "antd";
import { GlobalStateContext } from "./lib/GlobalContext";
import EgwInfoterminRegistration from "./pages/AnpassungRegistration/InfoterminRegistration";
import EgwAnpassungRegistration from "./pages/AnpassungRegistration/AnpassungRegistration";
import EgwClientarea from "./pages/Clientarea/Clientarea";
import { makeApiRequest } from "./lib/api";
// import EgwSurveyLauncher from "./pages/Clientarea/Survey/EgwSurveyLauncher";

if (process.env.NODE_ENV === "development") {
  require("./dev-index.css"); // Development-only styles
  require("./App.css"); // Development-only styles
} else {
  require("./App.css"); // Development-only styles
}

function App() {
  const { state, setState, resetAfterLoginUrl, notificationContextHolder } = useContext(GlobalStateContext);
  const [loading, setLoading] = useState(true);
  const [module, setModule] = useState(<Spin />);

  const redirectByTokenAuth = () => {
    const action = "REACT_TOKEN_VALIDATION";
    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("token")) {
      console.log("DEBUG: its  a token link", urlParams.get("token"));
      makeApiRequest(state.params!, action, { token: urlParams.get("token") }, true)
        .then((response) => {
          // console.log("DEBUG: is it a token link?", response);
          if (response) {
            const parsed = JSON.parse(response);
            if (parsed && parsed.STATUS === "OK" && parsed.CONTENT.token_params) {
              const tokenParams = parsed.CONTENT.token_params;
              const localParams: TypeParams = Object.fromEntries(new URLSearchParams(tokenParams).entries()) as any;
              const newParams = { ...state.params, ...localParams };
              // console.log("DEBUG: token newParams", newParams);
              setState((prevState: any) => ({ ...prevState, params: newParams }));
              return true;
            }
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!(window as any).params) {
      (window as any).params = {};
    }

    const urlParams = new URLSearchParams(window.location.search);

    let embeddedScript = true;
    if (urlParams && urlParams.has("ccid")) {
      // DEV: params as query params
      embeddedScript = false;
      const localParams: TypeParams = Object.fromEntries(urlParams.entries()) as any;
      if (localParams) {
        Object.keys(localParams).forEach((key: string) => {
          if (key in localParams) {
            const val: any = (localParams as any)[key];
            (window as any).params[key] = val as any;
          }
        });
      }
    }

    const localParams: TypeParams = (window as any).params;
    localParams.embeddedScript = embeddedScript;
    resetAfterLoginUrl();
    setState((prevState: any) => ({ ...prevState, params: localParams }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!state.params) {
      return;
    }

    let language = state?.params?.language;
    if (!language || language === "de") {
      language = "de-CH";
    }
    if (language === "it") {
      language = "it-CH";
    }
    if (language === "fr") {
      language = "fr-CH";
    }

    // console.log(language);
    i18n.changeLanguage(language);

    if (state.params) {
      state.params.dateFormat = "DD.MM.YYYY";
      if (state.params.language === "en") {
        state.params.dateFormat = "MM/DD/YYYY";
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.params, state.params?.language]);

  useEffect(() => {
    console.log("DEBUG LOG ACTIVATED", state?.params);

    if (!state?.params) {
      // WAIT
      console.log("DEBUG: No params provided, waiting for params");
      return;
    }

    if (!state?.params?.page || state.params.page === "token") {
      // CHECK FOR TOKEN REDIRECTION (if not page is provided)
      console.log("DEBUG: No page provided, checking for token redirection");
      redirectByTokenAuth();
      return;
    }

    switch (state.params.page) {
      case "anpassung_registration":
        setModule(
          <>
            <EgwAnpassungRegistration params={state.params} />
          </>
        );
        break;
      case "infotermin_registration":
        setModule(<EgwInfoterminRegistration params={state.params} />);
        break;
      case "kundenbereich":
        setModule(<EgwClientarea params={state.params} />);
        break;
      // case "survey_launcher":
      //   setModule(<EgwSurveyLauncher params={state.params} />);
      //   break;

      default:
        console.log("No page provided!!!");
        setModule(<>No page provided!</>);
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.params, state.params?.page]);

  if (!state.params) {
    return <Spin />;
  }

  if (!state.params.ccid) {
    return <>NO CCID provided!</>;
  }

  if (loading) {
    <Spin />;
  }

  return (
    <>
      {notificationContextHolder}
      <div style={{ maxWidth: 1200 }}>{module} </div>
    </>
  );
}

export default App;
